module.exports = __webpack_public_path__ + "static/img/t15.af27997d.png";